<template>
  <div>
    <el-form :model="info" ref="infoForm" label-width="100px" class="recommendForm" label-position="top">
      <el-form-item prop="title">
        <template #label>
          <em class="requireIcon">*</em>推荐擅长方向名称
        </template>
        <el-input v-model="info.title" class="redactinput" maxlength="10" show-word-limit
          placeholder="请输入推荐擅长方向名称"></el-input>
      </el-form-item>

      <el-form-item label="显示状态" prop="title">
        <el-switch v-model="info.status" active-color="#13ce66" inactive-color="#ff4949">
        </el-switch>
      </el-form-item>
      <div class="bigTitle el-form-item__label"><em class="requireIcon">*</em>选择二级分类（支持多选）</div>
      <div class="module" v-for="item in info.tag" :key="item.id">
        <div class="title">{{ item.title }}</div>
        <div class="chilBox">
          <div class="item" v-for="chilItem in item.list" :key="chilItem.id">
            <el-checkbox v-model="chilItem.selected">{{ chilItem.title }}</el-checkbox>
          </div>
        </div>
      </div>
    </el-form>

  </div>
</template>
<script>
  import { getRecommendInfo } from "@/api/psyAdept";
  export default {
    name:'updateRecommendGood',
    props: ['disabledid'],
    data(){
      return{
        info:{}
      }
    },
    watch:{
      info:{
        handler(newVal,oldVal){
          this.$emit("getInfo",this.info)
        },
        deep:true,
      }
    },
    created(){
      this.pageInfo()
    },
    methods:{
      pageInfo(){
        let that = this
        that.info = {}
        getRecommendInfo({
          id: that.disabledid,
        }).then((res) => {
          if (res.code) {
            that.info = res.data
          }
        })
      }
    }
  }
</script>
<style lang="scss" scoped>
  .requireIcon{
    color: red;
    margin-right: 5px;
  }
  .module{
    padding: 0 20px 10px;
    .title{
      margin-bottom: 10px;
    }
  }
  .chilBox{
    display: flex;
    flex-wrap: wrap;
    .item{
      white-space: nowrap;
      margin: 0 0 10px 20px;
    }
  }
</style>
<style lang="scss">
.recommendForm{
  .el-form-item__label{
    padding: 0;
    font-weight: bold;
  }
}
</style>